<template>
    <aside class="is-meta-panel card">
        <slot />
    </aside>
</template>

<script>
export default {
    name: 'MetaPanel',
};
</script>

<style lang="scss" scoped>
@import 'resources/scss/toolbox.scss';

.is-meta-panel {
    color: var(--p-text-color);
    background: var(--p-surface-color);
    border-radius: $radius-large;

}
</style>
